import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import curry from "./curry.js";
import toIter from "./toIter.js";
import nop from "./nop.js";
export default curry(function take(l, iter) {
  if (l < 1) return [];
  var res = [];
  iter = toIter(iter);
  return function recur() {
    var cur;

    while (!(cur = iter.next()).done) {
      var a = cur.value;

      if (a instanceof _Promise) {
        return a.then(function (a) {
          return (res.push(a), res).length == l ? res : recur();
        }).catch(function (e) {
          return e == nop ? recur() : _Promise.reject(e);
        });
      }

      res.push(a);
      if (res.length == l) return res;
    }

    return res;
  }();
});